import { defineMessages } from 'react-intl';

/**
 * The copy behind the "Run started" confirmation, headless.
 *
 * A run can start without a chat shell behind it (no project id). Nothing to
 * open, but the click must not read as dead — so it is confirmed with a toast,
 * and a toast is a design system effect this zone may not import. The
 * DESCRIPTOR is what crosses; the app-side delegate at
 * `src/features/workflows/hooks/runStartedToast.ts` formats and fires it.
 *
 * `defineMessages` and not a bare object literal: the formatjs extractor only
 * sees the call form, and the id below is the pre-move content hash, so no
 * catalogue entry moves.
 */
export const runStartedToastMessages = defineMessages({
  runStarted: {
    defaultMessage: 'Run started',
    id: 'lkWmHslz7+',
    description: 'Toast when a routine run starts without a chat to open',
  },
});
